export const DEP_ONLINE_SET_LOADING = 'DEP_ONLINE_SET_LOADING';
export const RESET_DRIVERS_DATA = 'RESET_DRIVERS_DATA';
export const RESET_RESULTS = 'RESET_RESULTS';
export const DEP_ONLINE_RESULT_SUCCESS = 'DEP_ONLINE_RESULT_SUCCESS';

export interface DepOnlineState {
  loading: boolean;
}

export interface SetResultLoadingType {
  type: typeof DEP_ONLINE_SET_LOADING;
  loading: boolean;
}

export interface ResetResultsType {
  type: typeof RESET_RESULTS;
}

export type DepOnlineTypes = SetResultLoadingType | ResetResultsType;
